import React from "react";
import { config } from "../../../../../config";

const UpdateFaq = ({ formData, setFormData, handleChange, handleSubmit, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update FAQ</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., common-questions"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Question</label>
          <input
            type="text"
            name="question"
            value={formData.question}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., How do I get started?"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Answer</label>
          <textarea
            name="answer"
            value={formData.answer}
            onChange={handleChange}
            className="border w-full p-2"
            rows="4"
            placeholder="Enter the detailed answer..."
            required
          ></textarea>
        </div>
         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update FAQ"}
            </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateFaq;